import { FC, useCallback } from 'react'
import { FloatingOverlay } from '@floating-ui/react'
import { useNavigate } from '@tanstack/react-router'
import ModalItem from 'components/ModalItem'
import { MODAL_IDS } from 'components/ModalProvider'
import { useIsTablet } from 'hooks'
import { OrderItem } from 'schema'

import { useGetOrderListQuery } from '../../api'
import { orderRoute } from '../../routes'
import OrderYarcheDetailDesktop from './OrderYarcheDetailDesktop'
import OrderYarcheDetailMobile from './OrderYarcheDetailMobile'

interface OrderYarcheDetailProps {
  order: OrderItem
}

const OrderYarcheDetail: FC<OrderYarcheDetailProps> = ({ order }) => {
  const isTablet = useIsTablet()
  const navigate = useNavigate()
  const { refetch } = useGetOrderListQuery('')

  const handleClose = useCallback(() => {
    navigate(orderRoute)
    refetch()
  }, [navigate, refetch])

  const commonProps = {
    order,
    onClose: handleClose
  }

  return (
    <ModalItem isOpen id={MODAL_IDS.OrderYarcheDetail}>
      <FloatingOverlay lockScroll className="z-modal bg-[#000]/[0.3]">
        {isTablet ? <OrderYarcheDetailMobile {...commonProps} /> : <OrderYarcheDetailDesktop {...commonProps} />}
      </FloatingOverlay>
    </ModalItem>
  )
}

export default OrderYarcheDetail
